// Shared tab strip that ties the Schedules page and the Availability
// page together into one logical section. Availability lives on its
// own view for URL/deep-link purposes, but the sidebar only exposes
// Schedules — captains flip to the availability matrix from here.
//
// Rendered only for elevated users (captains + admins). Regular
// players don't need the second surface; per-match RSVP lives on
// Schedule cards.

import React from "react";
import { CalendarDays, CheckCircle2 } from "lucide-react";
import { canDo } from "../data";

export const AVAILABILITY_ROLES = [
  "ADMIN","PRESIDENT","VICE_PRESIDENT",
  "CRICKET_HEAD","VOLLEYBALL_HEAD","CAPTAIN","VICE_CAPTAIN"
];

export default function ScheduleTabs({ user, active, navigate }) {
  const showAvailability = (user?.roles || []).some(r => AVAILABILITY_ROLES.includes(r)) ||
                           canDo(user, "availability", "update");
  if (!showAvailability) return null;

  return (
    <div className="schedTabs" role="tablist" aria-label="Schedule sections">
      <button
        type="button"
        role="tab"
        aria-selected={active === "schedule"}
        className={`schedTabs-btn${active === "schedule" ? " schedTabs-btn--active" : ""}`}
        onClick={() => navigate?.("schedule")}
      >
        <CalendarDays size={14}/> Schedule
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === "availability"}
        className={`schedTabs-btn${active === "availability" ? " schedTabs-btn--active" : ""}`}
        onClick={() => navigate?.("availability")}
      >
        <CheckCircle2 size={14}/> Team Availability
      </button>
    </div>
  );
}
